export const RESIDENCIES = ['us', 'ca'] as const

export type Residency = (typeof RESIDENCIES)[number]

export const DEFAULT_RESIDENCY: Residency = 'us'

export const parseResidency = (value: string | null | undefined): Residency | null => RESIDENCIES.find((residency) => residency === value) ?? null
